/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberSearchListArticleRequest } from "../models/MemberSearchListArticleRequest";
import type { MemberSearchListArticleResponseApiRespoonse } from "../models/MemberSearchListArticleResponseApiRespoonse";
import type { MemberSearchListGroupRequest } from "../models/MemberSearchListGroupRequest";
import type { MemberSearchListGroupResponseApiRespoonse } from "../models/MemberSearchListGroupResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class AppSearchService {
  /**
   * get articles
   * @param requestBody
   * @returns MemberSearchListArticleResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static userSearchArticles(
    requestBody: MemberSearchListArticleRequest
  ): CancelablePromise<MemberSearchListArticleResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/search/articles",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * get groups
   * @param requestBody
   * @returns MemberSearchListGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static userSearchGroups(
    requestBody: MemberSearchListGroupRequest
  ): CancelablePromise<MemberSearchListGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/search/groups",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
